import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

export interface IProductFilter {
    id?: EProductsId,
    checked: boolean,
    value: string,
}

export const productFilters: IProductFilter[] = [
    {
        id: undefined, // undefined означает, что это EProductsId.internet + EProductsId.tv и при этом не ломает тип
        checked: false,
        value: 'Интернет+ТВ',
    },
    {
        id: EProductsId.tv,
        checked: false,
        value: 'ТВ',
    },
    {
        id: EProductsId.internet,
        checked: false,
        value: 'Интернет',
    },
    {
        id: EProductsId.videoControl,
        checked: false,
        value: 'Видеонаблюдение',
    },
    {
        id: EProductsId.domofon,
        checked: false,
        value: 'Домофон',
    },
];
